// These map to states in the API
export const UPLOAD_STATES = {
  CREATED: 'Created',
  PROCESSING: 'Running',
  INGESTED: 'Ingested',
  REVIEW: 'Ingestedalt',
  MIGRATING: 'Migrating',
  DONE: 'Migrated',
  ERROR: 'Error',
};

export const FEATURE_STATE = {
  ALTERNATE: 'k', // alternate feature requiring approval
  APPROVED: 'a',
  DISCARDED: 'd',
  ERROR: 'e',
};

export const APPROVAL_OUTCOMES = {
  ACCEPT: 'a',
  DISCARD: 'd',
};

// labels that display a little extra context to users.
export const UPLOAD_LABELS = {
  [UPLOAD_STATES.CREATED]: 'Pending',
  [UPLOAD_STATES.PROCESSING]: 'Processing',
  [UPLOAD_STATES.INGESTED]: 'Ready to complete',
  [UPLOAD_STATES.REVIEW]: 'Action required',
  [UPLOAD_STATES.MIGRATING]: 'Creating collection',
  [UPLOAD_STATES.DONE]: 'Done',
  [UPLOAD_STATES.ERROR]: 'Error',
};
